// extracted by mini-css-extract-plugin
module.exports = {"page":"_17712","icon":"_9119","message":"_18247","button":"_13868"};